import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { MonitoringAlarm } from '../../models/monitoring-alarm';
import { TranslateService } from '@ngx-translate/core';
import { Message } from 'primeng/api/message';
import { environment } from '../../../../../environments/environment';
import { Subscription } from "rxjs";

@Component({
  selector: 'app-monitored-trains-cdc-alarms',
  template: require('./monitored-trains-cdc-alarms.component.html'),
  styles: [require('./monitored-trains-cdc-alarms.component.sass')]
})
export class MonitoredTrainsCdcAlarmsComponent implements OnInit {

    @Input() alarms: MonitoringAlarm[];
    @Input() projectId: number;

    alarmDateFormat = environment.alarms.dateFormat;

    selectedAlarm: MonitoringAlarm | undefined;
    selectedAlarmList: MonitoringAlarm[] = [];
    columns: any[]
    tableConfiguration: any = {
        paginate: true,
        sortableMode: 'multiple',
        defaultPagination: 250,
        itemsPerPageOptions: [50,100,250,500],
        exportFilename: 'CDC'
    }
    messages: Message[] = [{
        severity: 'info',
        summary: 'Info',
        detail: this.translate.instant('I18N_MONITORING.NO_ALARMS')
    }];

    languageChangeSubscription: Subscription;

    constructor(
        private translate: TranslateService,
    ) {
        this.languageChangeSubscription = this.translate.onLangChange.subscribe(() => {
            this.refreshCDCTable();
        })
    }


    ngOnInit(): void {
        this.refreshCDCTable();
    }


    refreshCDCTable = () =>{
        this.columns = [
            {
                header: this.translate.instant('I18N_MONITORING.PROJECT'),
                field: 'projectName',
                type: 'text'
            }, {
                header: this.translate.instant('I18N_MONITORING.HOST'),
                field: 'hostname',
                type: 'text'
            }, {
                header: this.translate.instant('I18N_MONITORING.DESCRIPTION'),
                field: 'description',
                type: 'text'
            }, {
                header: this.translate.instant('I18N_MONITORING.DATE'),
                field: 'lastChange',
                sortOrder: '-1'
            }, {
                header: this.translate.instant('I18N_MONITORING.ACKNOWLEDGED'),
                field: 'acknowledged'
            }
        ];
    }

}
